module.exports = __webpack_public_path__ + "static/media/component-11.d1140497.svg";